import { render, staticRenderFns } from "./PrivateOutlinesPage.vue?vue&type=template&id=2d2a02a6&"
import script from "./PrivateOutlinesPage.vue?vue&type=script&lang=js&"
export * from "./PrivateOutlinesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports